import { ExpandLess, ExpandMore } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import Modal from '../../../Modal';

const AgentTipsDebugInfo = ({ debuggerInfo }) => {
  const [doShowDetail, setDoShowDetail] = useState(false);
  const [viewingSections, setViewingSection] = useState([]);

  const handleViewSectionDetails = (segment) => {
    const viewingSectionsLatest = [...(viewingSections || [])];
    const indexOfSegToAdd = viewingSectionsLatest.indexOf(segment);
    if (indexOfSegToAdd > -1) {
      viewingSectionsLatest.splice(indexOfSegToAdd, 1);
    } else {
      viewingSectionsLatest.push(segment);
    }
    setViewingSection(viewingSectionsLatest);
  };

  const handleViewDetails = () => {
    setDoShowDetail((v) => !v);
  };

  const render = (debuggingInfo, name, heading) =>
    debuggingInfo && debuggingInfo.inputs ? (
      <div className="px-10 py-4">
        <a
          className="text-theme cursor-pointer"
          role="button"
          onKeyDown={() => {}}
          tabIndex="0"
          onClick={() => handleViewSectionDetails(name)}
        >
          {heading}
          {viewingSections.indexOf(name) > -1 ? <ExpandLess /> : <ExpandMore />}
        </a>
        {viewingSections.indexOf(name) > -1 && (
          <div>
            <pre>{debuggingInfo.inputs.join('\n')}</pre>
          </div>
        )}
      </div>
    ) : (
      <></>
    );

  return (
    <>
      <div
        className="text-theme cursor-pointer"
        role="menuitem"
        tabIndex="0"
        onClick={handleViewDetails}
        onKeyDown={() => {}}
      >
        View debugging info
      </div>
      <Modal open={doShowDetail} onClose={handleViewDetails}>
        {debuggerInfo.inputs && (
          <div className="px-10 py-4">
            <div className="font-bold">Main Inputs:</div>
            <pre>{debuggerInfo.inputs.join('\n')}</pre>
          </div>
        )}
        {debuggerInfo &&
          render(
            debuggerInfo.debugAlternativeAirports,
            'debugAlternativeAirports',
            'Alternative airports tips:',
          )}
        {debuggerInfo &&
          render(
            debuggerInfo.debugAlternativeArrivalDate,
            'debugAlternativeArrivalDate',
            'Alternative arrival date tips:',
          )}
        {debuggerInfo &&
          render(
            debuggerInfo.debugAlternativeCruiseDate,
            'debugAlternativeCruiseDate',
            'Alternative cruise date tips:',
          )}
        {debuggerInfo &&
          render(debuggerInfo.debugHotelDealsTips, 'debugHotelDealsTips', 'Hotel deals tips:')}
      </Modal>
    </>
  );
};

AgentTipsDebugInfo.propTypes = {
  debuggerInfo: PropTypes.objectOf(PropTypes.objectOf).isRequired,
};
export default memo(AgentTipsDebugInfo);
